<template>
  <div class="report_detailed">
    <headerSection :exam_type="reportData?.key || null" />

    <div class="container py-4 report_detailed_inner">
      <!-- Title -->
      <div class="" v-if="reportData">
        <div class="mb-3 p-2 px-4 bg-white">
          <p class="text-blue-main-toeic text-left mb-1 font-semibold m-0">{{ reportData?.created_at }}</p>
          <h3 class="text-center font-bold">多益{{ $route.params.practice_type === 'speaking' ? '口說' : '寫作' }}練習 {{ reportData.name }}　詳解</h3>
        </div>
        <div class="row mx-0 mb-2">
          <!-- Left Info -->
          <div class="col-md-4 text-center">
            <report_menu :examData="examTypeData" @emitSelectedIndex="emitSelectedIndex" />
          </div>

          <!-- Right Score -->
          <div class="col-md-8 text-center text-left px-0">
            <div class="p-2 px-4 d-flex align-items-center bg-white mb-2" v-if="currentReportData?.user_answer?.audio">
              <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">我的錄音</p>
              <audio controls :src="currentReportData.user_answer.audio" class="w-100 bg-white toeic-audio"></audio>
            </div>
            <!-- 發音語調重音 -->
            <div class="p-2 px-4 bg-white mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">發音語調重音</p>
                <a class="d-inline-block m-1 mx-2 pointer" style="max-width: 120px;" @click="showExplanation">
                  <img src="@/assets/image/toeic/toeic_exam/btn_analysis.png" alt="" class="object-contain w-100">
                </a>
              </div>
              <div class="text-left">
                <p class="m-0 font-semibold">發音 (Pronunciation)：<span class="text-orange-main-toeic">{{ pronScore.label_zh }}({{ pronScore.label_en }})</span></p>
                <p v-if="lang === 'zh'">{{ pronScore.zh }}</p>
                <p v-else>{{ pronScore.en }}</p>

                <p class="m-0 font-semibold">語調重音 (Intonation & Stress)：<span class="text-orange-main-toeic">{{ ProsodyScore.label_zh }}({{ ProsodyScore.label_en }})</span></p>
                <p v-if="lang === 'zh'">{{ ProsodyScore.zh }}</p>
                <p v-else>{{ ProsodyScore.en }}</p>
              </div>
            </div>
            <!-- AI批改結果 -->
            <div class="p-2 px-4 pt-3 bg-white mb-2">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">AI批改結果</p>
                <p class="m-0 text-xs" v-if="selectedIndex < 1"><span class="mr-2 text-green-main-toeic">●唸得很好</span><span class="mr-2 text-yellow-main-toeic">●需要加強</span><span class="mr-2 text-red-main-toeic">●唸得不清楚</span></p>
              </div>
              <p class="font-semibold gept_main_color p-2 text-left" v-html="correctResult" v-if="correctResult && selectedIndex < 1"></p>
              <p class="font-semibold gept_main_color p-2 text-left" v-if="selectedIndex > 0">{{ currentReportData?.result?.text }}</p>
              <div class="text-left mb-3" v-if="resultResult">
                <p v-if="resultResult && resultResult.result && resultResult.result.relevanceCheck"><span class="font-black">主題符合度：</span><br/>&emsp;&emsp;{{ resultResult.result.relevanceCheck }}</p>
                <p v-if="resultResult.result.completenessCheck"><span class="font-black">完整性檢查：</span><br/>&emsp;&emsp;{{ resultResult.result.completenessCheck }}</p>
                <p v-if="resultResult.content?.feedback"><span class="font-black">內容評語：</span><br/>&emsp;&emsp;{{ resultResult.content?.feedback }}</p>
                <p v-if="resultResult.organization?.feedback"><span class="font-black">組織評語：</span><br/>&emsp;&emsp;{{ resultResult.organization?.feedback }}</p>
                <span v-if="resultResult.grammar && resultResult.grammar.length > 0" class="font-black">文法檢查與句子修正：</span>
                <ul v-if="resultResult.grammar && resultResult.grammar.length > 0">
                  <li v-for="(item, index) in resultResult.grammar" :key="index">
                    <p>原句：{{ item.sentence }}</p>
                    <p>建議：{{ item.errorType }}</p>
                    <p>修正：{{ item.rewrite }}</p>
                  </li>
                </ul>
                <span v-if="resultResult.tips && resultResult.tips.length > 0" class="font-black">小提示：</span>
                <ul v-if="resultResult.tips && resultResult.tips.length > 0">
                  <li v-for="(item, index) in resultResult.tips" :key="index">
                    {{ item.feedback }}
                  </li>
                </ul>
                <!-- <p>{{ resultResult?.uiMessages?.completenessCheck }}</p>
                <p>{{ resultResult?.uiMessages?.relevanceCheck }}</p>
                <p>{{ resultResult?.uiMessages?.result }}</p> -->

                <p v-if="typeof resultResult === 'string'">{{ resultResult }}</p>
              </div>
            </div>
            <!-- 題目與解析 -->
            <div class="p-2 px-4 bg-white mb-2" v-if="questionAnalysis">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex pointer" @click="isShowAnalysis = !isShowAnalysis">
                  <span class="d-block mr-2"  :class="{ 'rotate-180': isShowAnalysis }">
                    <i class="fas fa-chevron-up"></i>
                    <!-- <i class="fas fa-chevron-down" v-else></i> -->
                  </span>
                  <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">題目與解析</p>
                </div>
                <a class="d-inline-block m-1 mx-2 pointer" style="max-width: 120px;" @click="showQuestion">
                  <img src="@/assets/image/toeic/toeic_exam/btn_check_subject.png" alt="" class="object-contain w-100">
                </a>
              </div>
              <!-- 參考答案 -->
              <div v-if="isShowAnalysis">
                <div class="d-flex align-items-center bg-white mb-2" v-if="currentAudioUrl">
                  <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap">參考答案</p>
                  <audio controls :src="currentAudioUrl" class="w-100"></audio>
                </div>
                <div class="text-left mb-3" v-html="questionAnalysis.explain.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
                <!-- <div class="text-left mb-3" v-html="currentReportData.result.question.Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
                <div class="text-left mb-3" v-html="currentReportData.result.question.Guide.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
                <div class="text-left mb-3" v-html="currentReportData.result.question.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div> -->
              </div>
            </div>
            <!-- <div class="p-3 bg-gray-toeic">
              <p class="max-w-xl mx-auto text-left m-0 text-lg">Directions: In this part of the test, you will read aloud the text on the screen. You will have 45 seconds to prepare. Then you will have 45 seconds to read the text aloud.</p>
            </div>
            <div class="p-3 mb-5">
              <p class="max-w-xl mx-auto text-left m-0 text-lg">Good evening, this is the National Weather Bureau’s report for Friday, October 15th. An arctic air mass originating from northern Canada is advancing southward, accompanied by gusty winds and torrential rainfall. Meteorologists anticipate that temperatures in metropolitan Chicago will plummet to approximately 42 degrees Fahrenheit overnight. Skies will gradually clear by Saturday morning, though the daytime high is projected to peak at a mere 55 degrees. Authorities urge residents across the Great Lakes corridor to brace for potential infrastructural disruptions and hazardous driving conditions. Meanwhile, coastal urban centers such as Boston and New York City will experience intermittent showers through the duration of the weekend. The frontal system is expected to dissipate by late Sunday afternoon, restoring fair weather. Thank you for listening—please remain vigilant and consult local updates for further advisories.</p>
            </div> -->
            <!-- <div class="d-flex justify-content-center align-content-center max-w-lg mx-auto w-100">
              <a class="d-inline-block m-1 mx-2 pointer">
                <img src="@/assets/image/toeic/toeic_exam/btn_myVoice.png" alt="" class="object-contain w-100">
              </a>
              <a class="d-inline-block m-1 mx-2 pointer" @click="swal_answer_analysis">
                <img src="@/assets/image/toeic/toeic_exam/btn_questionAnalysis.png" alt="" class="object-contain w-100">
              </a>
              <a class="d-inline-block m-1 mx-2 pointer" @click="swal_question_analysis">
                <img src="@/assets/image/toeic/toeic_exam/btn_AnswerAnalysis.png" alt="" class="object-contain w-100">
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
  import { mapActions, mapGetters } from 'vuex'
  import headerSection from '@/components/AiHelper/toeic/headerSection'
  import report_menu from '@/components/AiHelper/toeic/report_menu'
  import radarChart from '@/components/AiHelper/toeic/radarChart'
  import api from '@/store/api'
  import speakingLevels from '@/components/AiHelper/toeic/speakingLevels.js'
  export default {
    name: 'report_detailed',
    components: {
      headerSection,
      report_menu
    },
    data () {
      return {
        lang: 'zh',
        reportData: null,
        examData: null,
        questionAnalysis: null,
        selectedIndex: 0,
        selectedIndex2: 0,
        isShowAnalysis: false,
        speakingLevelsData: speakingLevels
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ]),
      examTypeData () {
        if (this.reportData && this.$route.params.practice_type === 'speaking') {
        return Array.isArray(this.examData?.Parts)
          ? this.examData.Parts.filter(
              el => el.IsSpeaking
            )
          : []
        }
        return Array.isArray(this.examData?.Parts)
          ? this.examData.Parts.filter(
              el => !el.IsSpeaking
            )
          : []
      },
      currentAudioUrl () {
        if (this.selectedIndex2 === 0) return this.currentPartQuestions?.AudioUrl1 || ''
        if (this.selectedIndex2 === 1) return this.currentPartQuestions?.AudioUrl2 || ''
        if (this.selectedIndex2 === 2) return this.currentPartQuestions?.AudioUrl3 || ''
        return ''
      },
      currentReportData () {
        if (this.reportData) {
          return this.reportData.part[this.selectedIndex].data[this.selectedIndex2]
        }
        return null
      },
      currentPartQuestions () {
        return this.examTypeData[this.selectedIndex]
      },
      pronScore () {
        let score = this.currentReportData?.result?.ers?.LPronScore || 0
        if (score === 3) return this.speakingLevelsData.pronunciation_intonation.Pronunciation.high
        if (score === 2) return this.speakingLevelsData.pronunciation_intonation.Pronunciation.medium
        return this.speakingLevelsData.pronunciation_intonation.Pronunciation.low
      },
      ProsodyScore () {
        let score = this.currentReportData?.result?.ers?.LprosodyScore || 0
        if (score === 3) return this.speakingLevelsData.pronunciation_intonation.IntonationAndStress.high
        if (score === 2) return this.speakingLevelsData.pronunciation_intonation.IntonationAndStress.medium
        return this.speakingLevelsData.pronunciation_intonation.IntonationAndStress.low
      },
      correctResult () {
        const words = this.currentReportData?.result?.ers?.Words
        if (!Array.isArray(words) || words.length === 0) return ''

        const htmlWords = words.map(item => {
          const word = item.Word || ''
          const errorType = item.ErrorType
          let color = ''

          switch (errorType) {
            case 'None':
              color = 'text-green-main-toeic'
              break
            case 'Mispronunciation':
            case 'Monotone':
              color = 'text-yellow-main-toeic'
              break
            case 'Omission':
              color = 'text-red-main-toeic'
              break
            case 'Insertion':
              return ''
            default:
              return ''
          }

      // ⚙️ 有顏色才加 <span>
      return color
        ? `<span class="${color}" font-weight:bold;">${word}</span>`
        : word
        }).join(' ')

        return htmlWords
      },

      resultResult() {
        const data = this.currentReportData?.result?.result;
        if (!data) return ''

        try {
          return JSON.parse(data);
        } catch (e) {
          return data
        }
      }

    },
    mounted () {
      this.getData()
    },
    methods: {
      ...mapActions({
        doGetPoints: 'getRemainPoints'
      }),
      getData () {
        let path = `/assessments/records/${this.$route.params.record_id}`

        api.get(path)
        .then((res) => {
          this.reportData = res.data
          this.getExamData(res.data.exam_id)
        })
        .catch((err) => {
          console.log(err)
        })
      },
      getExamData (exam_id) {
        let path = `https://api.liveabc.com/v1/livelibrary/Exam/${exam_id}`

        api.get(path)
        .then((res) => {
          this.examData = res.data.data
          this.getQuestionAnalysisData(res.data.data.Parts[0].Questions[0].Id)
        })
        .catch((err) => {
          console.log(err)
        })
      },
      getQuestionAnalysisData (question_id) {
        let path = `https://api.liveabc.com/v1/livelibrary/Question/${question_id}?showAnswer=true&showExplain=true`

        api.get(path)
        .then((res) => {
          this.questionAnalysis = res.data.data
          // console.log(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
      },
      swal_answer_analysis () {
        this.$swal({
          html: `<p class="font-bold text-left">整體發音練習建議</p><p class="text-left">先慢唸整段，注意正確連音與停頓，尤其是句子之間的自然斷句
專有名詞如「Blue Valley Inn」「Lake Mead」需清晰、正確唸出
關鍵片語 （avoid vacation stress、personal attention、greatest treasure）可稍作停頓或強調，突顯語意
複合句（如 While staying at our inn.）語調應自然滑順，不要斷裂
形容詞串列 （spacious rooms, swimming pool and many outdoor activities）語調要有節奏感，避免平淡
廣告語氣應溫和、有吸引力，尤其是最後一句標語 “A happy guest is our greatest treasure."，可略帶微笑語氣朗讀，展現誠意與熱情</p>`,
          showConfirmButton: false,
          showCloseButton: true,
          focusConfirm: false,
          confirmButtonText: `我知道了`,
          title: '題目解析',
          customClass: {
            title: 'text-white bg-blue-lighter-toeic text-2xl pb-3',
            container: '',
            popup: 'p-0 max-w-3xl w-100',
            header: 'position-relative',
            closeButton: 'closeButton position-absolute',
            htmlContainer: 'my-3',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      },
      swal_question_analysis () {
        this.$swal({
          html: `
            <div class="text-left">
              <p class="text-black">發音清楚、語調自然，雖然有些單字略不清楚，但整體語意傳達完整。朗讀能掌握適當停頓與句子斷句，表現流暢。若能再加強部分片語（如 “spectacular sights”）的清晰度，並加入更多語氣變化，會更具吸引力。</p>
              <div class="row my-4">
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Accuracy<br>準確度</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">60</div>
                  </div>
                </div>
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Fluency<br>流暢度</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">80</div>
                  </div>
                </div>
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Completeness<br>完整度</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">50</div>
                  </div>
                </div>
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Prosody<br>韻律</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">70</div>
                  </div>
                </div>
              </div>
              <div class="chart-wrapper mx-auto" style="width: 300px; max-width: 100%;">
                <div id="radarChartContainer" class="my-4"></div>
              </div>
            </div>
          `,
          didOpen: () => {
            // 動態建立 radarChart 元件
            const RadarChartClass = Vue.extend(radarChart)
            const instance = new RadarChartClass({
              propsData: {
                // 可以傳你的分數進去
                accuracy: 60,
                fluency: 80,
                completeness: 50,
                prosody: 70
              }
            })
            instance.$mount('#radarChartContainer')
          },
          showConfirmButton: false,
          showCloseButton: true,
          focusConfirm: false,
          title: '回答分析',
          customClass: {
            title: 'text-white bg-blue-lighter-toeic text-2xl pb-3',
            container: '',
            popup: 'p-0 max-w-3xl w-100',
            header: 'position-relative',
            closeButton: 'closeButton position-absolute',
            htmlContainer: 'my-3',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      },
      audio_play () {
        if (!this.sound_effect) return
        this.sound_effect.play()
        this.sound_effect.addEventListener('ended', () => {
          this.audio_stop()
        })
      },
      audio_stop () {
        // this.isPlayingAudio = false
        this.sound_effect.pause()
        this.sound_effect.currentTime = 0
      },

      emitSelectedIndex (payload) {
        this.selectedIndex = payload.index
        this.selectedIndex2 = payload.qIndex

        this.getQuestionAnalysisData(this.examData.Parts[payload.index].Questions[payload.qIndex].Id)
      },
      showExplanation () {
        this.$swal({
          title: '<h4 class="text-white mb-3">解析說明</h4>',
          html: `
            <div class="text-left swal-content-wrapper" style="font-size:16px; line-height:1.6;">
              <p>口說測驗部分，另外針對考生在發音（Pronunciation）及語調與重音（Intonation and Stress）兩方面的表現分別給予評分（分高、中、低三級），並含其他能力敘述。</p>

              <!-- 發音等級 -->
              <table class="table table-bordered mt-3 text-center symmetric-table">
                <thead class="text-white" style="background-color:#a578d2;">
                  <tr>
                    <th>發音等級（Pronunciation）</th>
                    <th>說明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>低 Low</td><td>朗讀時，發音不容易理解。</td></tr>
                  <tr><td>中 Medium</td><td>朗讀時，發音普通可以理解，但有時還是會有錯誤。</td></tr>
                  <tr><td>高 High</td><td>朗讀時，發音非常容易可以理解。</td></tr>
                </tbody>
              </table>

              <!-- 語調與重音等級 -->
              <table class="table table-bordered mt-3 text-center symmetric-table">
                <thead class="text-white" style="background-color:#a578d2;">
                  <tr>
                    <th>語調與重音等級（Intonation and Stress）</th>
                    <th>說明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>低 Low</td><td>朗讀時，語調與重音的使用不是很適當。</td></tr>
                  <tr><td>中 Medium</td><td>朗讀時，語調與重音的使用大致還算適當。</td></tr>
                  <tr><td>高 High</td><td>朗讀時，語調與重音的使用非常適當。</td></tr>
                </tbody>
              </table>
            </div>
          `,
          width: 800,
          background: '#0074b7',
          showConfirmButton: false,
          showCloseButton: true,
          customClass: {
            htmlContainer: 'm-0 p-0', // ✅ 移除 swal 預設左右 padding
            popup: 'rounded-lg shadow-lg p-0 position-relative bg-white max-w-4xl w-100',
            content: 'p-4',
            closeButton: 'text-white closeButton',
            title: '',
            header: 'bg-blue-lighter-toeic pb-2'
          }
        })
      },
      showQuestion () {
        let testHtml
        let Description = `<div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">Directions</p>
              <audio id="userDescription" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.currentPartQuestions?.Description}</p>
          </div>`
        let Answer = `<div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">參考答案</p>
              <audio id="userAnswer" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.currentPartQuestions?.Questions[this.selectedIndex2].Title}</p>
          </div>`
        let ImageUrl = `<div>
            ${this.currentPartQuestions?.Questions[this.selectedIndex2].ImageUrl
                ? `<div class="question-image mb-4">
                    <img src="${this.currentPartQuestions?.Questions[this.selectedIndex2].ImageUrl}" alt="Question image" class="img-fluid rounded shadow-sm" />
                </div>`
                : ''
            }
          </div>`
        let stemInformationPic = `<div>
            ${this.currentPartQuestions?.stemInformationPic
                ? `<div class="question-image mb-4">
                    <img src="${this.currentPartQuestions?.stemInformationPic}" alt="Question image" class="img-fluid rounded shadow-sm" />
                </div>`
                : ''
            }
          </div>`
        let stemQuestionsWords = `<div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">題幹</p>
              <audio id="useStemQuestionsAudio" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.currentPartQuestions?.stemQuestionsWords || ''}</p>
          </div>`
        let onlyStemQuestionsWords = `<div>
            <p class="text-left">${this.currentPartQuestions?.stemQuestionsWords || ''}</p>
          </div>`
        let Title = `<div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">題目</p>
              <audio id="userAudioUrl" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.currentPartQuestions?.Questions[this.selectedIndex2]?.Title?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''}</p>
          </div>`
          let customTitle = `<div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">題目</p>
              <audio id="userCustomTitle" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.currentPartQuestions?.Questions[this.selectedIndex2]?.Title?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''}</p>
            <p class="text-left">${this.currentPartQuestions?.Questions[this.selectedIndex2]?.Answer || ''}</p>
          </div>`
          console.log(this.currentPartQuestions?.Questions[this.selectedIndex2])
          if (this.reportData.key !== 'toeic') { // bridge
            if (this.selectedIndex === 0) {
              testHtml = Description + Answer
            } else if (this.selectedIndex === 1) {
              testHtml = Description + ImageUrl
            } else if (this.selectedIndex === 2) {
              testHtml = Description + onlyStemQuestionsWords + customTitle
            } else if (this.selectedIndex === 3) {
              testHtml = Description + Title + stemInformationPic
            } else if (this.selectedIndex === 4) {
              testHtml = Description + stemInformationPic
            } else if (this.selectedIndex === 5) {
              testHtml = Description + Title + ImageUrl
            }
          } else { // toeic
            if (this.selectedIndex === 0) {
              testHtml = Description + Answer
            } else if (this.selectedIndex === 1) {
              testHtml = Description + ImageUrl
            } else if (this.selectedIndex === 2) {
              testHtml = Description + stemQuestionsWords + Title
            } else if (this.selectedIndex === 3) {
              testHtml = Description + stemInformationPic + stemQuestionsWords + Title
            } else if (this.selectedIndex === 4) {
              testHtml = Description + stemQuestionsWords
            } else if (this.selectedIndex === 5) {
              testHtml = Description + Title + ImageUrl
            }
          }

        this.$swal({
          title: '<h4 class="text-white mb-0 py-2">題目</h4>',
          html: testHtml,
          width: 800,
          background: '#0074b7',
          showConfirmButton: false,
          showCloseButton: true,
          customClass: {
            htmlContainer: 'm-0 p-0',
            popup: 'rounded-lg shadow-lg p-0 position-relative bg-white max-w-4xl w-100',
            content: 'p-4',
            closeButton: 'text-white closeButton',
            title: '',
            header: 'bg-blue-lighter-toeic pb-2'
          },
          didOpen: () => {
            const userDescription = document.getElementById('userDescription')
            const userAnswer = document.getElementById('userAnswer')
            const userAudioUrl = document.getElementById('userAudioUrl')
            const useStemQuestionsAudio = document.getElementById('useStemQuestionsAudio')
            const userCustomTitle = document.getElementById('userCustomTitle')
            if (userDescription && this.currentPartQuestions.DescriptionAudioUrl) {
              userDescription.src = this.currentPartQuestions.DescriptionAudioUrl
            }
            if (userAnswer && (this.currentPartQuestions.AudioUrl1 || this.currentPartQuestions.AudioUrl2 || this.currentPartQuestions.AudioUrl3)) {
              if (this.selectedIndex2 === 0) userAnswer.src = this.currentPartQuestions.AudioUrl1
              if (this.selectedIndex2 === 1) userAnswer.src = this.currentPartQuestions.AudioUrl2
              if (this.selectedIndex2 === 2) userAnswer.src = this.currentPartQuestions.AudioUrl3
            }
            if (userAudioUrl && this.currentPartQuestions?.Questions[this.selectedIndex2].AudioUrl) {
              userAudioUrl.src = this.currentPartQuestions?.Questions[this.selectedIndex2].AudioUrl
            }
            if (useStemQuestionsAudio && this.currentPartQuestions.stemQuestionsAudio) {
              useStemQuestionsAudio.src = this.currentPartQuestions.stemQuestionsAudio
            }
            if (userCustomTitle && this.currentPartQuestions?.Questions[this.selectedIndex2].AudioUrl) {
              userCustomTitle.src = this.currentPartQuestions?.Questions[this.selectedIndex2].AudioUrl
            }
          }
        })
      }
    }
  }
</script>
<style lang="scss">
.report_detailed {
  .report_detailed_inner {
    min-height: 160vh;
  }
  a {
    &:hover {
      text-decoration: none !important;
    }
  }
  .bg-gray-toeic {
    background-color: #C0C0C0;
  }
  .bg-gray-toeic2 {
    background-color: rgba(240, 240, 240, 1);
  }

  audio::-webkit-media-controls-panel {
    background-color: #ffffff !important;
  }
  .swal2-popup {
    color: #333;
  }
  .table th, .table td {
    vertical-align: middle !important;
  }
}
  .closeButton {
    position: absolute;
    top: 5px;
    right: 0;
  }
.swal2-html-container {
  padding: 0 !important;
  margin: 0 auto !important;
  width: 90%;
}

/* 讓表格左右完全對稱、欄位等寬 */
.symmetric-table {
  table-layout: fixed;
  width: 100%;
  background-color: #f9f3ff;
}
.symmetric-table th,
.symmetric-table td {
  vertical-align: middle;
  text-align: center;
  padding: 12px;
  border-color: #ddd;
}
.toeic-audio::-webkit-media-controls-panel {
    background-color: #ffffff !important;
  }
.rotate-180 {
  display: inline-block;     /* transform 對 inline 元素沒作用，改成 inline-block 或 block */
  transform: rotate(180deg);
  transform-origin: center;  /* 設定旋轉中心，可改成 left/right/top/bottom 或百分比 */
}
</style>
